import React, { useState, useEffect } from "react";
import "./application-accordion.css"
import { TrashIcon } from "@heroicons/react/outline"
const AppplicationAccordionItem = ({ onClick, index, onRemove, isActive, title, children, is_optional }) => {

    return <div className={"app-accordion-item " + (isActive ? 'active' : '')}>
        <span className="title"><button className="label" type="button" onClick={() => { onClick(index) }}>{title}</button>
            {(index > 0 || is_optional) && <button className="remove" type="button" onClick={() => onRemove(index)}><TrashIcon className="w-4 h-4 text-red-500" /> Remove</button>}
        </span>

        <div className="app-accordion-content">
            {children}
        </div>
    </div>

}

const ApplicationAccordion = ({ children, onRemove, is_optional }) => {
    const [activeItem, setActiveItem] = useState([]);
    useEffect(() => {
        var m = true;
        if (m) {

            setActiveItem((state) => ([...state, children.length - 1]));
        }
        return () => {
            m = false;
        }
    }, [children])
    return <div className="app-accordion">
        {children && children.map((child, index) => {

            return <AppplicationAccordionItem is_optional={is_optional} index={index} key={index} isActive={activeItem.indexOf(index) > -1} onClick={(i) => {

                if (activeItem.indexOf(i) === -1) {

                    setActiveItem((state) => ([...state, i]));

                } else {
                    var activeItems = [...activeItem];
                    activeItems = activeItems.filter((f, key) => {
                        return i !== f;
                    })
                    setActiveItem(activeItems);
                }

            }} onRemove={(i) => { onRemove(i) }} title={child.props.title}>
                <div className="inner-content">{child.props.children}</div>
            </AppplicationAccordionItem>
        })}
    </div>
}


export default ApplicationAccordion